
import { EMPTY_REFUND_ENTITY, RefundEntity } from "domain/entity/Refund/RefundEntity";
import { EMPTY_REFUND_SEARCH_CRITERIA, RefundSearchCriteria } from "domain/entity/Refund/RefundSearchCriteria";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface RefundDropdownOptions {
    companyCodeDropdownOptions: DropdownProps[],
    refundTypeDropdownOptions: DropdownProps[],
    statusDropdownOptions: DropdownProps[],
    bankCodeDropdownOptions: DropdownProps[],
    reasonCodeDropdownOptions: DropdownProps[],
}

export interface RefundViewChangeState extends BaseViewChangeSate {
}


export interface RefundModel {
    masterState: RefundViewChangeState,
    isLoading: boolean,
    searchCriteria: RefundSearchCriteria,
    dynamicOptions: RefundDropdownOptions,
    refundList: RefundEntity[],
    isShowSearchPanel: boolean,
    isShowOperationPanel: boolean,
    isShowEditPanel: boolean,
    isEdit: boolean,
    isAdd: boolean,
    selectedRows: RefundEntity[],
    currentRow: RefundEntity,
    currentEditRow: RefundEntity,
    forceRefresh: boolean,
    reasonCode: string,
    bankerIdAndBankerAcNo: string,
    operation: string,
    isSearchLoading: boolean,
}

export const EMPTY_REFUND_MODEL: RefundModel = {
    isLoading: false,
    refundList: [],
    isShowSearchPanel: false,
    isShowEditPanel: false,
    isEdit: false,
    isAdd: false,
    selectedRows: [],
    currentRow: { ...EMPTY_REFUND_ENTITY },
    currentEditRow: { ...EMPTY_REFUND_ENTITY },
    dynamicOptions: {
        companyCodeDropdownOptions: [],
        refundTypeDropdownOptions: [],
        statusDropdownOptions: [],
        bankCodeDropdownOptions: [],
        reasonCodeDropdownOptions: [],
    },
    searchCriteria: { ...EMPTY_REFUND_SEARCH_CRITERIA },
    forceRefresh: false,
    reasonCode: "",
    isShowOperationPanel: false,
    bankerIdAndBankerAcNo: "",
    operation: "",
    isSearchLoading: true,
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        }
    }
}